import { render, staticRenderFns } from "./knowledge-base.vue?vue&type=template&id=a1ed3680&scoped=true&lang=pug&"
import script from "./knowledge-base.vue?vue&type=script&lang=js&"
export * from "./knowledge-base.vue?vue&type=script&lang=js&"
import style0 from "./knowledge-base.vue?vue&type=style&index=0&id=a1ed3680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ed3680",
  null
  
)

export default component.exports